<template>
    <div>
        <center-header />
        <div class="about">
            <!-- 面包屑导航 -->
            <div class="breadcrumb" style="text-align: left;">
                <router-link to="/">首页</router-link>
                <span class="separator"> &gt; </span>
                <span>关于我们</span>
            </div>
            <!-- 页面内容 -->
            <div class="about-content">
                <div class="about-title">{{ detail.name }}</div>
                <div class="about-text">
                    <p v-html="detail.content"></p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
// 导入头部和底部组件
import CenterHeader from './shopCenter/components/CenterHeader.vue'
export default {
    name: 'About',
    components: {
        CenterHeader,
    },
    data() {
        return {
            detail: {
                title: '',
                create_time: '',
                content: ''
            }
        }
    },
    mounted() {
        this.getData();
    },
    methods: {
        getData() {
            this.$api.getAboutUsDetail({
                column_id: '9'
            }).then(res => {
                this.detail = res;
            }).catch(err => {
                this.$message.error(err.message)
            })
        }
    }
}
</script>

<style scoped>
.about {
    padding: 20px;
    max-width: 1200px;
    margin: 0 auto;
}

.breadcrumb {
    font-size: 14px;
    color: #666;
    margin-bottom: 20px;
}

.separator {
    margin: 0 8px;
}

.about-content {
    background-color: #fff;
    padding: 20px 40px;
    border-radius: 8px;
    box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.about-title {
    font-size: 24px;
    font-weight: bold;
    color: #333;
    text-align: center;
    margin-bottom: 16px;
}

.about-date {
    font-size: 14px;
    color: #999;
    text-align: center;
    margin-bottom: 32px;
}

.about-text {
    font-size: 16px;
    line-height: 1.8;
    color: #333;
}

.about-text p {
    margin-bottom: 20px;
    text-align: justify;
}
</style>